import i18n from "@/i18n";
import { CardVue } from "fs-pb-vue2/vueModels/contracts/CardVue";
import { ContractsTypes } from "fs-pb-vue2/data/enums/contractsTypes";
import cardState from "fs-pb-vue2/filters/cardState.filter";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import {OperationsApi} from "fs-pb-vue2/services/api/OperationsApi";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { Prop, Watch } from "vue-property-decorator";
import { container } from "@/inversify.config";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { RequestParamsModel } from "fs-pb-vue2/models/statement/requestParamsModel";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";
import IConfigService  from "fs-pb-vue2/services/config/IConfigService";
import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";

/** Модель представления счета */
export class CardVueGB extends CardVue {
  @Watch("configStore.apiData.ShowcaseFile", { immediate: true })
  async onShowcaseFileChanged(newVal: string, oldVal: string): Promise<void> {
    if (newVal !== oldVal) {
      await this.getShowcase();
    }
  }
  
  @Watch('$route.query.notification', { immediate: true })
  onNotificationQueryChanged(newVal: string, oldVal: string): void {
    if (newVal === 'true' && newVal !== oldVal) {
      this.openNotificationDialog();
    }
  }

  openNotificationDialog(): void {
    const params = localStorage.getItem('cardNotificationParams');
    if (params) {
      this.dialogContent = new Object({
        vueName: "CardOperationNotifications",
        params: JSON.parse(params)
      });
      this.dialog = true;
    }
  }

  /**
   * Сервис вывода уведомлний
   */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  get ConfigService(): IConfigService {
    return container.get<IConfigService>(DiTokens.ConfigService);
  }

  payAction(): void {
    if (this.contract.Data.ContractType === 2 || this.contract.Data.ContractType === 1) 
        this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfToContract}?contract=${this.contract.Data.ReferenceId}`)
    else
        this.$router.push(`/payments?contract=${this.contract.Data.ReferenceId}`)
  }

  get historyOnDisplay(): boolean {
    return this.$route.query.history === 'true';
  }

  get limitsOnDisplay(): boolean {
    return this.$route.query.limits === 'true';
  }

  get reqsOnDisplay(): boolean {
    return this.$route.query.reqs === 'true';
  }

  get notificationOnDisplay(): boolean {
    return this.$route.query.notification === 'true';
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  get mobileOnDisplay(): boolean {
    return (!this.historyOnDisplay) || this.windowWidthCalc > 970;
  }

  // Признак видимости предложения выбора категорий кешбэка
  get isCashbackSelectOfferVisible(): boolean {
    return this.card.Data.selectMode == 2 && !this.hasCurrentCashbackCategories;
  }

  get hasCurrentCashbackCategories(): boolean {
    return this.card.Data.visible == 1;
  }

  loadHistory(): void {
    this.$router.push({path: this.$route.fullPath, query: { 'history': 'true' }})
  }

  changeDisplayCard(): void {
    this.mainCardOnDisplay = !this.mainCardOnDisplay;
  }

  showNumber: boolean = false;
  showCVV: boolean = false;

  mainCardOnDisplay: boolean = true;

  cardVisibleDigits: string = '';
  cardCVV: string = '';

  showcaseList: ShowcasePageData[] = [];

  /**
   * Загрузка списка ShowcaseFile
   */
  async getShowcase(): Promise<void> {
    this.showcaseList = await this.ConfigService.fetchShowcase(this.configStore.apiData.ShowcaseFile);
  }

  /**
   * Проверка наличия страницы с указанным ID
   */
  isCardOperationNotificationsAvailable(cardOperNotifShowcaseId: string | number): boolean {
    return !!this.showcaseList.find((page: ShowcasePageData) => page.Id.toString() === cardOperNotifShowcaseId.toString());
  }

  async showNumberFunc(): Promise<void> {
    this.showNumber = true;
    try {
      await this.loadCardDetails();

      if (!this.cardVisibleDigits) {
        this.showNumber = false;
        this.alertService.error('Ошибка получения номера карты');
      }

      try {
        await navigator.clipboard.writeText(this.cardVisibleDigits);
        this.alertService.success('Номер карты скопирован');
      } catch (err) {
        const inp = document.createElement('input');
        inp.value = this.cardVisibleDigits;
        document.body.appendChild(inp);
        inp.select();

        document.execCommand("copy");
        document.body.removeChild(inp);
      }

      setTimeout(() => {
        if (this.showNumber) {
          this.showNumber = false;
        }
      }, 30000);

    } catch (e: any) {
        this.showNumber = false;
        this.alertService.error('Ошибка получения номера карты');
        console.error("Error:", e.message);
    }
  }

  // Время последнего запроса CVV2/CVV2
  private lastCVVRequestTime: number = 0; 

  // Время в секундах, после которого можно повторно отправить запрос CVV2/CVV2
  private readonly retryTimeoutSeconds: number = 60;

  private getSecondsWord(number: number): string {
    const lastDigit = number % 10;
    if (number >= 11 && number <= 19) {
      return 'секунд';
    }
    if (lastDigit === 1) {
      return 'секунду';
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
      return 'секунды';
    }
    return 'секунд';
  }

  async showCVVFunc(): Promise<void> {
    const currentTime = Date.now();
    const timeSinceLastRequest = currentTime - this.lastCVVRequestTime;
  
    if (timeSinceLastRequest < this.retryTimeoutSeconds * 1000) {
      const secondsRemaining = Math.ceil((this.retryTimeoutSeconds * 1000 - timeSinceLastRequest) / 1000);
      const secondsWord = this.getSecondsWord(secondsRemaining);
      this.alertService.info(`Повторный запрос CVV2/CVC2 станет возможен через ${secondsRemaining} ${secondsWord}.`);
      return;
    }

    this.showCVV = true;
    try {
      await this.loadCardDetails();
      this.lastCVVRequestTime = Date.now();

      if (!this.cardCVV) {
        this.showCVV = false;
        this.alertService.info(i18n.t('main.cards.actions.cvvIsNotAvailable').toString());
        return;
      }

      try {
        await navigator.clipboard.writeText(this.cardCVV);
        this.alertService.success('CVC2/CVV2 скопирован в буфер обмена');
      } catch (err) {
        const inp = document.createElement('input');
        inp.value = this.cardCVV;
        document.body.appendChild(inp);
        inp.select();

        document.execCommand("copy");
        document.body.removeChild(inp);
      }

      // Таймер на автоматическое скрытие CVV2/CVV2 через 30 секунд
      setTimeout(() => {
        if (this.showCVV) {
          this.showCVV = false;
        }
      }, 30000);

    } catch(e: any) {
      this.showCVV = false;
      this.alertService.error(e.message);
    }
  }

  getCardState(state: any): string {
    return cardState(state);
  }

  async callAction(action: () => Promise<void>) {
    await action();
  }

  async getCVV(): Promise<void> {
    this.alertService.info(i18n.t('main.cards.actions.cvvIsNotAvailable').toString());
  }

  async loadCardDetails() {
    try {
      const params: RequestParamsModel = new RequestParamsModel({ take: 1, skip: 0, sortType: 1, respondentName: 'GetCardDetails', cardId: this.card.Data.Id });
      const respData: any = await ContractsApi.fillList(params);

      if (respData && respData.result === "ok" && respData.data && respData.data.Data.Properties) {
        const properties = respData.data.Data.Properties;
        if (properties.cardNumber) {
          const cardNumber: string = respData.data.Data.Properties.cardNumber;
          this.cardVisibleDigits = cardNumber.replace(/(.{4})/g, "$1 ");
        }
        if (properties.cardCVV) {
          this.cardCVV = properties.cardCVV;
        }
      }
    } catch(e: any) {
      this.alertService.error(e.message);
    }
  }

  /**
 * Действия с картой
 * @returns {Array<any>} - массив действий
 */
  get actions(): Array<any> {
    const actions: Array<any> = [];
    if (this.contract && this.card) {
      if (!this.card.IsIssued) {
        /**Действие запроса выписки по счету*/
        actions.push({
          text: i18n.t("main.cards.actions.statement"),
          iconClass: "statement-icon",
          action: () => {
            // this.statementMode = true;
            this.$router.push(
              `/statement/${this.contract.Data.Id}/${this.card.Data.Id}`
            );
          }
        });
      }
      if (this.card.Data.selectMode !== 0) {
        /**Выбрать категорию кэшбэк */
        actions.push({
          text: i18n.t("main.cards.actions.chooseCashBack"),
          iconClass: "choose-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "ChooseCashBack",
              params: { contract: this.contract, card: this.card }
            });
            this.dialog = true;
          }
        });
      }
      if (this.card.Data.transferMode !== 0 && this.card.Data.transferMode == 2) {
        /**Потратить кэшбэк */
        actions.push({
          text: i18n.t("main.cards.actions.spendCashBack"),
          iconClass: "spend-card-icon",
          action: () => {
            this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfTransferCashBack}?contract=${this.contract.Data.ReferenceId}&card=${this.card.Data.ReferenceId}`);
          }
        });
      }
      // if (
      //   this.configStore.apiData.OperationCodeOfCardPinCode && this.card.Data.MainCard != '0'
      // ) {
      //   // /**Сменить пин код */
      //   actions.push({
      //     text: i18n.t("main.cards.actions.changePin"),
      //     iconClass: "change-pin-icon",
      //     action: () => {
      //       // this.dialogContent = new Object({
      //       //   vueName: "CardPinModal",
      //       //   params: { card: this.card, contract: this.contract }
      //       // });
      //       // this.dialog = true;
      //       this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfCardPinCode}`);
      //     }
      //   });
      // }
      /**Уведомления об операциях CardOperationNotifications*/
      if(this.isCardOperationNotificationsAvailable(this.card.Data.cardOperNotifShowcaseId)) {
        actions.push({
          text: i18n.t("main.cards.actions.transactionsNtification"),
          iconClass: "ntification-icon",
          action: () => {
            const params = { showcaseList: this.showcaseList, card: this.card };
            localStorage.setItem('cardNotificationParams', JSON.stringify(params));
            this.$router.push({ 
              path: this.$route.path, 
              query: { notification: 'true' } 
            }).then(() => {
              this.dialog = true;
            });
          }
        });
      }
      /**Установить лимиты */
      actions.push({
        text: i18n.t("main.cards.actions.setLimits"),
        iconClass: "set-limits-icon",
        action: () => {            
          this.dialogContent = new Object({
            vueName: "CardLimitsModal",
            params: { 
              card: this.card,
              cardRefId: this.card.Data.ReferenceId,
              contract: this.contract,
            }
          })
          this.$router.push({path: this.$route.fullPath, query: { 'limits': 'true' }})
        },
      });
      if (this.card.Data['MainCard'] != '0') {
        /**Действие запроса реквизитов счета */
        actions.push({
          text: i18n.t("main.cards.actions.requisits"),
          iconClass: "requisits-icon",
          action: () => {
            this.$router.push({ path: this.$route.fullPath, query: { 'reqs': 'true' } });
          }
        });
      }
      if (this.card.IsActive) {
        /**Блокировка карты */
        actions.push({
          text: i18n.t("main.cards.actions.blockCard"),
          iconClass: "block-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "CardBlockModal",
              params: {
                isBlock: true,
                contract: this.contract,
                card: this.card
              }
            });
            this.dialog = true;
          }
        });
        if (this.card.Data.ReissuedCatId) {
          /** Перевыпуск карты */
          actions.push({
            text: i18n.t("main.cards.actions.reissuedCard"),
            iconClass: "reissued-card-icon",
            action: () => {
              this.$router.push(`/operation/0/${this.card.Data.ReissuedCatId}?_categoryName=${this.$i18n.t("main.cards.actions.reissuedCard")}&contract=${this.contract.Data.ReferenceId}&card=${this.card.Data.ReferenceId}`);
            }
          });
        }
      } else if (this.card.IsBlocked) {
        /**Блокировка карты */
        actions.push({
          text: i18n.t("main.cards.actions.unblockCard"),
          iconClass: "block-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "CardBlockModal",
              params: {
                isBlock: false,
                contract: this.contract,
                card: this.card
              }
            });
            this.dialog = true;
          }
        });
      }


    }
    return actions;
  }

}